module.exports = __webpack_public_path__ + "static/img/banner.5c417b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/banner.png
// module id = p0+3
// module chunks = 171